import Immutable from 'immutable';

const SkillScoreRecord = Immutable.Record({
  skillId: undefined,
  name: undefined,
  score: undefined,
});

export default class SkillScore extends SkillScoreRecord { }



// WEBPACK FOOTER //
// ./data/AcademicInfo/SkillScore/model.js